// Form validation utilities

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateEventName = (name) => {
  if (!name || name.trim().length === 0) {
    return 'Event name is required';
  }
  if (name.length > 100) {
    return 'Event name must be less than 100 characters';
  }
  return null;
};

export const validateEventDate = (date) => {
  if (!date) {
    return 'Event date is required';
  }
  return null;
};

export const validateEventType = (type) => {
  if (!type) {
    return 'Event type is required';
  }
  return null;
};

export const validatePassword = (password) => {
  if (!password) {
    return 'Password is required';
  }
  if (password.length < 6) {
    return 'Password must be at least 6 characters';
  }
  return null;
};
